import {
  STORAGE_AGENDA_EMPLOYEE_SELECTION,
  STORAGE_AGENDA_LAYOUT_CONFIG,
  STORAGE_AGENDA_ROOM_SELECTION,
  STORAGE_COMPANY_SETTINGS,
  STORAGE_USER,
} from 'commons/constants';

export const STORAGE_LAST_SELECTED_AGENDA_DISPLAY_TYPE =
  'minhaagenda-spa-STORAGE_LAST_SELECTED_AGENDA_DISPLAY_TYPE';
export const STORAGE_DEFAULT_EMPLOYEE = 'minhaagenda-spa-STORAGE_DEFAULT_EMPLOYEE';
export const LAST_SELECTED_REPEAT_END_TYPE = 'minhaagenda-spa-LAST_SELECTED_REPEAT_END_TYPE';
export const SHOWN_HELP_FOR_ITEM_KEY = 'minhaagenda-spa:SHOWN_HELP_FOR_ITEM_KEY';
export const STORAGE_WHATSAPP_IS_DESKTOP = 'minhaagenda-spa-STORAGE_WHATSAPP_IS_DESKTOP';
export const STORAGE_BIRTHDAY_SETTINGS = 'minhaagenda-spa-STORAGE_BIRTHDAY_SETTINGS';

const StorageService = {
  getCurrentUser() {
    const loggedInUserInStorage = window.localStorage.getItem(STORAGE_USER);
    if (loggedInUserInStorage && loggedInUserInStorage !== 'undefined') {
      try {
        return JSON.parse(loggedInUserInStorage);
      } catch (e) {
        console.log(e);
      }
    }
    return null;
  },

  setCurrentUser(loggedInUser) {
    window.localStorage.setItem(STORAGE_USER, JSON.stringify(loggedInUser));
  },

  setCompanySettings(companySettings) {
    window.localStorage.setItem(STORAGE_COMPANY_SETTINGS, JSON.stringify(companySettings));
  },

  removeCompanySettings() {
    window.localStorage.setItem(STORAGE_COMPANY_SETTINGS, null);
  },

  removeUser() {
    window.localStorage.setItem(STORAGE_USER, null);
  },

  getDefaultAgendaDisplayType() {
    return window.localStorage.getItem(STORAGE_LAST_SELECTED_AGENDA_DISPLAY_TYPE);
  },
  setDefaultAgendaDisplayType(displayType) {
    window.localStorage.setItem(STORAGE_LAST_SELECTED_AGENDA_DISPLAY_TYPE, displayType);
  },
  getDefaultEmployeeId() {
    const employeeIdString = window.localStorage.getItem(STORAGE_DEFAULT_EMPLOYEE);
    return employeeIdString != null && employeeIdString !== '' ? Number.parseInt(employeeIdString) : null;
  },
  setDefaultEmployeeId(employeeId) {
    window.localStorage.setItem(STORAGE_DEFAULT_EMPLOYEE, employeeId ? `${employeeId}` : null);
  },

  setDefaultRepeatEndType(repeatEndTypeSelected) {
    window.localStorage.setItem(LAST_SELECTED_REPEAT_END_TYPE, repeatEndTypeSelected);
  },
  getDefaultRepeatEndType() {
    const selectedString = window.localStorage.getItem(LAST_SELECTED_REPEAT_END_TYPE);
    return selectedString != null && selectedString !== '' ? Number.parseInt(selectedString) : null;
  },

  getShownHelpForItemConfig() {
    const configAsString = window.localStorage.getItem(SHOWN_HELP_FOR_ITEM_KEY);

    try {
      return configAsString != null ? JSON.parse(configAsString) : {};
    } catch (err) {
      console.log(err);
    }
    return {};
  },

  setHasShownHelpForItem(itemName) {
    const shownHelpForItemConfig = this.getShownHelpForItemConfig();
    shownHelpForItemConfig[itemName.toUpperCase()] = true;
    window.localStorage.setItem(SHOWN_HELP_FOR_ITEM_KEY, JSON.stringify(shownHelpForItemConfig));
  },

  hasShownHelpForItem(itemName) {
    const shownHelpForItemConfig = this.getShownHelpForItemConfig();
    return shownHelpForItemConfig[itemName.toUpperCase()];
  },

  setIsWhatsAppDesktop(isWhatsAppDesktop) {
    window.localStorage.setItem(STORAGE_WHATSAPP_IS_DESKTOP, `${isWhatsAppDesktop}`);
  },
  getIsWhatsAppDesktop() {
    const selectedString = window.localStorage.getItem(STORAGE_WHATSAPP_IS_DESKTOP);
    return selectedString != null && selectedString !== '' ? selectedString === 'true' : true;
  },

  hasNotSelectedWhatsApp() {
    const selectedString = window.localStorage.getItem(STORAGE_WHATSAPP_IS_DESKTOP);
    return selectedString == null;
  },

  getAgendaEmployeeSelection() {
    const configAsString = window.localStorage.getItem(STORAGE_AGENDA_EMPLOYEE_SELECTION);

    try {
      return configAsString != null ? JSON.parse(configAsString) : {};
    } catch (err) {
      console.log(err);
    }
    return {};
  },

  setAgendaRoomSelection(newSelectionRooms) {
    window.localStorage.setItem(STORAGE_AGENDA_ROOM_SELECTION, JSON.stringify(newSelectionRooms));
  },
  getAgendaRoomSelection() {
    const configAsString = window.localStorage.getItem(STORAGE_AGENDA_ROOM_SELECTION);

    try {
      return configAsString != null ? JSON.parse(configAsString) : {};
    } catch (err) {
      console.log(err);
    }
    return {};
  },

  setAgendaLayoutConfig(angedaLayoutConfig) {
    window.localStorage.setItem(STORAGE_AGENDA_LAYOUT_CONFIG, JSON.stringify(angedaLayoutConfig));
  },
  getAgendaLayoutConfig() {
    const selString = window.localStorage.getItem(STORAGE_AGENDA_LAYOUT_CONFIG);
    try {
      return selString != null ? JSON.parse(selString) : null;
    } catch (err) {
      console.log(err);
    }
    return {};
  },

  getBirthdaySettings() {
    const configAsString = window.localStorage.getItem(STORAGE_BIRTHDAY_SETTINGS);

    try {
      return configAsString != null ? JSON.parse(configAsString) : null;
    } catch (err) {
      console.log(err);
    }
    return null;
  },
  setBirthdaySettings(birthdaySettings) {
    window.localStorage.setItem(STORAGE_BIRTHDAY_SETTINGS, JSON.stringify(birthdaySettings));
  },
};
export default StorageService;
